import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import Loading from './Loading'
import { PAGINAS_PERMISSAO } from '../lib/permissoes'

function SemAcesso() {
  const { podeAceder } = useAuth()
  const primeira = PAGINAS_PERMISSAO.find(p => podeAceder(p.chave))
  return (
    <main style={{ maxWidth: '480px', margin: '64px auto', padding: '0 24px', textAlign: 'center' }}>
      <div style={{ fontSize: '52px', marginBottom: '16px', lineHeight: 1 }}>🔒</div>
      <h2 style={{ marginBottom: '10px' }}>Sem acesso</h2>
      <p style={{ color: 'var(--cor-texto-suave)', marginBottom: '24px', lineHeight: 1.6 }}>
        Não tens permissão para aceder a esta página.<br />Contacta o administrador.
      </p>
      <Link
        to={primeira?.to || '/'}
        className="btn-primario"
        style={{ textDecoration: 'none', display: 'inline-block' }}
      >
        Ir para uma página disponível
      </Link>
    </main>
  )
}

// Envolve uma página do backoffice e só a mostra se o utilizador atual tiver
// acesso a essa página (segundo a matriz de permissões). Caso contrário mostra
// um ecrã "sem acesso" — sem redirecionar, para evitar ciclos.
export default function ComPermissao({ pagina, children }) {
  const { carregando, podeAceder } = useAuth()
  if (carregando) return <div style={{ padding: '64px 24px' }}><Loading /></div>
  if (!podeAceder(pagina)) return <SemAcesso />
  return children
}
